import { BrowserRouter, Routes, Route } from "react-router-dom";
import WelcomePage from "./pages/WelcomePage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import EmployeeDashboardPage from "./pages/EmployeeDashboardPage";
import UsersPage from "./pages/UsersPage";
import CoursesPage from "./pages/CoursesPage";
import TestsPage from "./pages/TestsPage";
import AdminAnalysisPage from "./pages/AdminAnalysisPage";
import ProtectedRoute from "./components/ProtectedRoute";
import CourseEditPage from "./pages/CourseEditPage";
import EmployeeCourseLearningPage from "./pages/EmployeeCourseLearningPage";

import AdminNotificationsPage from "./pages/AdminNotificationsPage";

import SettingsPage from "./pages/SettingsPage";



import EmployeeSettingsPage from "./pages/EmployeeSettingsPage";

import ChatPage from "./pages/ChatPage";
import EmployeeChatPage from "./pages/EmployeeChatPage";

import SubCoursesPage from "./pages/SubCoursesPage";


import EmployeeCoursesPage from "./pages/EmployeeCoursesPage";





function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
  <AdminDashboardPage />
</ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/courses"
          element={
            <ProtectedRoute>
              <CoursesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/tests"
          element={
            <ProtectedRoute>
              <TestsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-analysis"
          element={
            <ProtectedRoute>
              <AdminAnalysisPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/courses/edit/:courseId"
          element={
            <ProtectedRoute>
              <CourseEditPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/employee-dashboard"
          element={
            <ProtectedRoute allowedRoles={["employee"]}>
  <EmployeeDashboardPage />
</ProtectedRoute>
          }
        />

        <Route
          path="/employee-courses/:courseId"
          element={
            <ProtectedRoute>
              <EmployeeCourseLearningPage />
            </ProtectedRoute>
          }
        />

        

        <Route
  path="/admin-notifications"
  element={
    <ProtectedRoute>
      <AdminNotificationsPage />
    </ProtectedRoute>
  }
/>

<Route
  path="/settings"
  element={
    <ProtectedRoute>
      <SettingsPage />
    </ProtectedRoute>
  }
/>





<Route
  path="/employee-settings"
  element={
    <ProtectedRoute>
      <EmployeeSettingsPage />
    </ProtectedRoute>
  }
/>

<Route
  path="/chat"
  element={
    <ProtectedRoute>
      <ChatPage />
    </ProtectedRoute>
  }
/>

<Route
  path="/employee-chat"
  element={
    <ProtectedRoute allowedRoles={["employee"]}>
      <EmployeeChatPage />
    </ProtectedRoute>
  }
/>

<Route
  path="/courses/category/:categoryId"
  element={
    <ProtectedRoute>
      <SubCoursesPage />
    </ProtectedRoute>
  }
/>


<Route
  path="/employee-my-courses"
  element={
    <ProtectedRoute allowedRoles={["employee"]}>
      <EmployeeCoursesPage />
    </ProtectedRoute>
  }
/>





      </Routes>
    </BrowserRouter>
  );
}

export default App;